import React, { useState } from 'react';
import { X, ShoppingBag, CheckCircle } from 'lucide-react';

const BuyModal = ({ product, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    quantity: 1
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Store order in localStorage (mock)
    const orders = JSON.parse(localStorage.getItem('easy2home_orders') || '[]');
    const newOrder = {
      id: Date.now(),
      product: product,
      customer: formData,
      orderDate: new Date().toISOString(),
      status: 'pending',
      total: product.price * formData.quantity
    };
    orders.push(newOrder);
    localStorage.setItem('easy2home_orders', JSON.stringify(orders));
    
    setSubmitted(true);
    setTimeout(() => {
      onClose();
    }, 3000);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#fffef2',
        maxWidth: '600px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        position: 'relative',
        borderRadius: '0px'
      }}>
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px'
          }}
        >
          <X size={24} color="#333333" />
        </button>

        {!submitted ? (
          <div style={{ padding: '40px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
              <ShoppingBag size={32} color="#333333" />
              <h2 className="heading-2">Complete Your Purchase</h2>
            </div>

            {/* Product Summary */}
            <div style={{
              backgroundColor: '#f6f5e8',
              padding: '20px',
              marginBottom: '32px',
              display: 'flex',
              gap: '16px'
            }}>
              <img 
                src={product.image}
                alt={product.name}
                style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover'
                }}
              />
              <div style={{ flex: 1 }}>
                <h3 className="body-regular" style={{ fontWeight: '500', marginBottom: '8px' }}>
                  {product.name}
                </h3>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                  <span className="heading-3">₹{product.price.toLocaleString()}</span>
                  <span className="body-small" style={{ 
                    color: '#bcbbb4', 
                    textDecoration: 'line-through' 
                  }}>
                    ₹{product.originalPrice.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>

            {/* Order Form */}
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label className="body-regular" style={{ 
                  display: 'block', 
                  marginBottom: '8px',
                  fontWeight: '500'
                }}>
                  Full Name *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #bcbbb4',
                    borderRadius: '0px',
                    backgroundColor: '#fffef2',
                    fontSize: '14px',
                    fontFamily: 'Inter, sans-serif'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label className="body-regular" style={{ 
                  display: 'block', 
                  marginBottom: '8px',
                  fontWeight: '500'
                }}>
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #bcbbb4',
                    borderRadius: '0px',
                    backgroundColor: '#fffef2',
                    fontSize: '14px',
                    fontFamily: 'Inter, sans-serif'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label className="body-regular" style={{ 
                  display: 'block', 
                  marginBottom: '8px',
                  fontWeight: '500'
                }}>
                  Phone Number *
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #bcbbb4',
                    borderRadius: '0px',
                    backgroundColor: '#fffef2',
                    fontSize: '14px',
                    fontFamily: 'Inter, sans-serif'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label className="body-regular" style={{ 
                  display: 'block', 
                  marginBottom: '8px',
                  fontWeight: '500'
                }}>
                  Delivery Address *
                </label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  rows="3"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #bcbbb4',
                    borderRadius: '0px',
                    backgroundColor: '#fffef2',
                    fontSize: '14px',
                    fontFamily: 'Inter, sans-serif',
                    resize: 'vertical'
                  }}
                />
              </div>

              <div style={{ marginBottom: '24px' }}>
                <label className="body-regular" style={{ 
                  display: 'block', 
                  marginBottom: '8px',
                  fontWeight: '500'
                }}>
                  Quantity
                </label>
                <input
                  type="number"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  min="1"
                  max="10"
                  style={{
                    width: '100px',
                    padding: '12px 16px',
                    border: '1px solid #bcbbb4',
                    borderRadius: '0px',
                    backgroundColor: '#fffef2',
                    fontSize: '14px',
                    fontFamily: 'Inter, sans-serif'
                  }}
                />
              </div>

              {/* Total */}
              <div style={{
                backgroundColor: '#f6f5e8',
                padding: '16px',
                marginBottom: '24px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <span className="body-regular" style={{ fontWeight: '500' }}>
                  Total Amount:
                </span>
                <span className="heading-2">
                  ₹{(product.price * formData.quantity).toLocaleString()}
                </span>
              </div>

              <button type="submit" className="btn-primary" style={{ width: '100%' }}>
                Place Order
              </button>

              <p className="body-small" style={{ 
                color: '#666666', 
                marginTop: '16px',
                textAlign: 'center'
              }}>
                Our team will contact you shortly to confirm your order and arrange payment.
              </p>
            </form>
          </div>
        ) : (
          <div style={{
            padding: '60px 40px',
            textAlign: 'center'
          }}>
            <CheckCircle size={64} color="#333333" style={{ margin: '0 auto 24px' }} />
            <h2 className="heading-2" style={{ marginBottom: '16px' }}>
              Order Placed Successfully!
            </h2>
            <p className="body-large" style={{ color: '#666666', marginBottom: '8px' }}>
              Thank you for your order, {formData.name}!
            </p>
            <p className="body-regular" style={{ color: '#666666' }}>
              We'll contact you at {formData.phone} to confirm your order.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BuyModal;
